var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "AppCard",
    [
      _c("v-card-title", {
        staticClass: "headline justify-center font-weight-bold",
        domProps: { textContent: _vm._s(_vm.title) }
      }),
      _vm._v(" "),
      _c("v-card-subtitle", {
        staticClass: "text-center",
        domProps: {
          textContent: _vm._s(
            _vm.$auth.user.role === _vm.Role.Admin
              ? "A Preview of All Users in the Database"
              : "A Preview of All Users You've invited"
          )
        }
      }),
      _vm._v(" "),
      _c(
        "v-card-text",
        [
          _c(
            "v-row",
            { attrs: { align: "center", justify: "center" } },
            [
              _vm.invitedUsers.length > 0
                ? _c("v-data-table", {
                    staticClass: "elevation-1",
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.invitedUsers,
                      "items-per-page": 3,
                      "footer-props": {
                        "items-per-page-options": [3]
                      },
                      "fixed-header": ""
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "item.appUser.role",
                          fn: function(ref) {
                            var item = ref.item
                            return [
                              item.appUser.role === _vm.Role.Admin
                                ? _c(
                                    "AppDialog",
                                    {
                                      attrs: {
                                        disabled:
                                          _vm.$auth.user.role !==
                                          _vm.Role.Admin,
                                        activatorText: "mdi-checkbox-marked",
                                        title:
                                          "Set " +
                                          item.appUser.email +
                                          "'s role to center user?",
                                        icon: true,
                                        action: "Change Role",
                                        hint:
                                          "Promote the user to admin or reset them to a normal user (centerUser)."
                                      },
                                      on: {
                                        action: function($event) {
                                          return _vm.toggleRole(
                                            item,
                                            _vm.Role.CenterUser
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("div", [
                                        _vm._v(
                                          "\n              Are you sure you want to set this user to a center user?\n            "
                                        )
                                      ])
                                    ]
                                  )
                                : _c(
                                    "AppDialog",
                                    {
                                      attrs: {
                                        disabled:
                                          _vm.$auth.user.role !==
                                          _vm.Role.Admin,
                                        activatorText:
                                          "mdi-checkbox-blank-outline",
                                        title:
                                          "Set " +
                                          item.appUser.email +
                                          "'s role to center user?",
                                        icon: true,
                                        action: "Change Role",
                                        hint:
                                          "Promote the user to super admin. The user will now be able to delete and create new trials, centers and anonymization configs, as well as promote other users to super admin."
                                      },
                                      on: {
                                        action: function($event) {
                                          return _vm.toggleRole(
                                            item,
                                            _vm.Role.Admin
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("div", [
                                        _vm._v(
                                          "Are you sure you want to promote this user to admin?"
                                        )
                                      ])
                                    ]
                                  )
                            ]
                          }
                        },
                        {
                          key: "item.userInvite.expired",
                          fn: function(ref) {
                            var item = ref.item
                            return [
                              item.appUser.deactivated
                                ? _c("v-icon", {
                                    attrs: { color: "red" },
                                    domProps: {
                                      textContent: _vm._s(
                                        "mdi-minus-circle-outline"
                                      )
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.showReactivateUserDialog(
                                          item
                                        )
                                      }
                                    }
                                  })
                                : item.appUser.role === _vm.Role.Admin
                                ? _c("v-icon", {
                                    attrs: { color: "green" },
                                    domProps: {
                                      textContent: _vm._s("mdi-alpha-a-circle")
                                    }
                                  })
                                : !item.userInvite.expired && !item.appUser.id
                                ? _c("v-icon", {
                                    attrs: { color: "yellow" },
                                    domProps: {
                                      textContent: _vm._s(
                                        "mdi-clock-time-four-outline"
                                      )
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.showDeleteUserInviteDialog(
                                          item
                                        )
                                      }
                                    }
                                  })
                                : !item.appUser.deactivated
                                ? _c("v-icon", {
                                    attrs: { color: "green" },
                                    domProps: {
                                      textContent: _vm._s("mdi-check-circle")
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.showDeactivateUserDialog(
                                          item
                                        )
                                      }
                                    }
                                  })
                                : _vm._e()
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1183055999
                    )
                  })
                : _c("p", {
                    domProps: {
                      textContent: _vm._s("No user invites have been sent yet.")
                    }
                  })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card-actions",
        { staticClass: "justify-center" },
        [
          _c(
            "v-btn",
            {
              attrs: { "x-large": "", text: "" },
              on: {
                click: function($event) {
                  return _vm.handleClickUsersYouInvited()
                }
              }
            },
            [
              _c("v-icon", {
                staticClass: "secondary--text",
                domProps: { textContent: _vm._s("mdi-face") }
              }),
              _vm._v("\n      View All Users\n    ")
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }